import { render } from "./SyncOnec.vue?vue&type=template&id=23f5b814&scoped=true&ts=true"
import script from "./SyncOnec.vue?vue&type=script&lang=ts"
export * from "./SyncOnec.vue?vue&type=script&lang=ts"

import "./SyncOnec.vue?vue&type=style&index=0&id=23f5b814&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f5b814"]])

export default __exports__